export default "__VITE_ASSET__7yXU4RBq__"